// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column">

    <table class="table ">
      <thead>
      <th>Bank name</th>
      <th>Account name</th>
      <th>Account number</th>
      <th>BRSTN</th>
      <th>Branch name</th>
      <th ng-if="\$ctrl.editMode"></th>
      </thead>
      <tbody class="tbody">

      <tr ng-repeat="a in \$ctrl.profile.externalAccounts">
        <td><div class="bank">{{\$ctrl.banksMap[a.bankId].description}}</div></td>
        <td>{{a.accountName}}</td>
        <td>{{a.accountNumber}}</td>
        <td>{{a.brstn || '-'}}</td>
        <td>{{a.branchName}}</td>
        <td ng-if="\$ctrl.editMode">
          <button type="button" class="btn-danger" ng-click="\$ctrl.remove(a)">Remove</button>
        </td>
      </tr>

      <tr ng-if="\$ctrl.editMode">
        <td>
          <selectize
            class="bank"
            ng-required="(\$ctrl.profile.externalAccounts.length < 1) && (\$ctrl.banks && \$ctrl.banks.length > 0)"
            options="\$ctrl.banks"
            config="\$ctrl.bankSelectConfig"
            ng-model="\$ctrl.externalAccount.bankId">
          </selectize>
        </td>
        <td>
          <input type="text"
                 maxlength="128"
                 ng-model="\$ctrl.externalAccount.accountName"
                 ng-required="\$ctrl.profile.externalAccounts.length < 1"/>
        </td>
        <td>
          <input type="text"
                 maxlength="24"
                 ng-model="\$ctrl.externalAccount.accountNumber"
                 ng-required="\$ctrl.profile.externalAccounts.length < 1"/>
        </td>
        <td>
          <input type="text"
                 minlength="9"
                 maxlength="9"
                 ui-mask="999999999"
                 ng-model="\$ctrl.externalAccount.brstn"
                 ng-required="false"/>
        </td>
        <td>
          <input type="text"
                 maxlength="24"
                 ng-model="\$ctrl.externalAccount.branchName"
                 ng-required="\$ctrl.profile.externalAccounts.length < 1"/>
        </td>
        <td>
          <button type="button" class="btn btn-success" ng-click="\$ctrl.add()">
            Add
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div ng-if="\$ctrl.profile.externalAccounts.length < \$ctrl.minAccounts">
      <input class="hidden-element" disabled ng-required="true" ng-model="nonExistingValue"/>
    </div>
  </div>
</ng-form>
<div class="clearfix"></div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/external-accounts.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;